// extracted by css-extract-rspack-plugin
export default {"dialog":"SamsClub-module__dialog___Z5gvG","container":"SamsClub-module__container___0OrDd","containerMobile":"SamsClub-module__containerMobile___nukKy"};